import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import noteService from "../../../../../services/noteService";
import dateService from "../../../../../services/dateService";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

import ListDate from "../ListDate";
import AddTime from "../time/AddTime";
import ListTime from "../time/ListTime";
import AddDocument from "../document/AddDocument";
import ListDocuments from "../document/ListDocument";
import ListNote from "../ListNote";

function CustomTabPanel(props=({children: "", value: "", index: ""})) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <MDBox m={1}>{children}</MDBox>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function Header({ children = "",  expedienteId = null}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(Number(searchParams.get("tab")) || 0);
  const [title, setTitle] = useState("");
  const [note, setNote] = useState("");
  const [arrangedDate, setArrangedDate] = useState("");
  const [entity, setEntity] = useState("");
  const [link, setLink] = useState("");
  const [contactDate, setContactDate] = useState("");
  const [descriptionDate, setDescriptionDate] = useState("");
  const [successSB, setSuccessSB] = useState(false);
  const closeSuccessSB = () => setSuccessSB(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const closeErrorSB = () => setErrorSB(false);
  const [refreshNotes, setRefreshNotes] = useState(false);
  const [refreshDates, setRefreshDates] = useState(false);
  const [refreshTimes, setRefreshTimes] = useState(false);
  const [refreshDocuments, setRefreshDocuments] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const addNote = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const nota = {
      expedienteId,
      title,
      note,
    };

    const data = await noteService.createNote(nota);
    setErrorMessage(data);
    if (data === 200) {
      setSuccessSB(true);
      setNote("");
      setTitle("");
      setRefreshNotes((prev) => !prev);
    } else {
      setErrorSB(true);
    }
    setSubmitting(false);
  };

  const addDate = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const newDate = {
      expedienteId,
      arrangedDate,
      link,
      contact: contactDate,
      entity,
      description: descriptionDate,
    };

    const data = await dateService.createDate(newDate);
    setErrorMessage(data);
    if (data === 200) {
      setSuccessSB(true);
      setArrangedDate("");
      setContactDate("");
      setEntity("");
      setLink("");
      setDescriptionDate("");
      setRefreshDates((prev) => !prev);
    } else {
      setErrorSB(true);
    }
    setSubmitting(false);
  };

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    setSearchParams((prev) => { prev.set("tab", newValue); return prev; });
  };

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Registro procesado correctamente!"
      content="Registro procesado correctamente!"
      dateTime=""
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Error"
      content={errorMessage}
      dateTime=""
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  return (
    <MDBox position="relative" mb={5}>
      <Grid container spacing={0} alignItems="center">
        <Grid item xs={12} md={8} lg={6}>
          <Tabs
            orientation={tabsOrientation}
            value={tabValue}
            onChange={handleSetTabValue}
            xs={12}
            md={6}
            lg={4}
          >
            <Tab
              label="Nota"
              icon={
                <Icon fontSize="small" sx={{ mt: -0.25 }}>
                  notes
                </Icon>
              }
            />
            <Tab
              label="Agenda"
              icon={
                <Icon fontSize="small" sx={{ mt: -0.25 }}>
                  event
                </Icon>
              }
            />
            <Tab
              label="Tiempo"
              icon={
                <Icon fontSize="small" sx={{ mt: -0.25 }}>
                  <TimerOutlinedIcon />
                </Icon>
              }
            />
            <Tab
              label="Documento"
              icon={
                <Icon fontSize="small" sx={{ mt: -0.25 }}>
                  folder_open
                </Icon>
              }
            />
          </Tabs>
        </Grid>
      </Grid>
      <CustomTabPanel value={tabValue} index={0}>
        <Card>
          <MDBox position="relative" p={1}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={12}>
              <form onSubmit={addNote}>
                <Accordion
                  style={{ boxShadow: "none" }}
                  sx={{
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark"
                        ? theme.palette.action.hover
                        : "transparent !important",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <MDTypography display="block" variant="button" fontWeight="regular">
                      Agregar nueva nota
                    </MDTypography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MDBox mb={2} mt={-1}>
                      <MDInput
                        fullWidth
                        type="text"
                        label="Titulo"
                        value={title}
                        required
                        onChange={(event) => {
                          setTitle(event.target.value);
                        }}
                      />
                    </MDBox>
                    <MDBox>
                      <MDInput
                        fullWidth
                        type="text"
                        label="Descripción"
                        value={note}
                        multiline
                        rows={3}
                        onChange={(event) => {
                          setNote(event.target.value);
                        }}
                      />
                    </MDBox>
                  </AccordionDetails>
                  <AccordionActions>
                    <MDButton variant="gradient" color="success" type="submit" disabled={submitting}>
                      Agregar
                    </MDButton>
                    {renderSuccessSB}
                    {renderErrorSB}
                  </AccordionActions>
                </Accordion>
              </form>
              </Grid>
            </Grid>
          </MDBox>
        </Card>

        <MDBox pt={3}>
          <ListNote expedienteId={expedienteId} refreshNotes={refreshNotes} />
        </MDBox>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <Card>
          <MDBox position="relative" p={1}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={12}>
                <form onSubmit={addDate}>
                  <Accordion
                    style={{ boxShadow: "none" }}
                    sx={{
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark"
                          ? theme.palette.action.hover
                          : "transparent !important",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <MDTypography display="block" variant="button" fontWeight="regular">
                        Agregar nueva fecha de reunión
                      </MDTypography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <MDBox mb={2} mt={-1}>
                        <MDInput
                          mb={3}
                          type="datetime-local"
                          label=""
                          value={arrangedDate}
                          required
                          onChange={(event) => {
                            setArrangedDate(event.target.value);
                          }}
                        />
                      </MDBox>
                      <MDBox mb={2}>
                        <MDInput
                          fullWidth
                          type="text"
                          label="Link de conexión o lugar de reunión"
                          value={link}
                          required
                          onChange={(event) => {
                            setLink(event.target.value);
                          }}
                        />
                      </MDBox>
                      <MDBox mb={2}>
                        <MDInput
                          fullWidth
                          type="text"
                          label="Parte representada"
                          multiline
                          value={entity}
                          onChange={(event) => {
                            setEntity(event.target.value);
                          }}
                        />
                      </MDBox>
                      <MDBox mb={2}>
                        <MDInput
                          fullWidth
                          type="text"
                          label="Contacto"
                          multiline
                          rows={3}
                          value={contactDate}
                          onChange={(event) => {
                            setContactDate(event.target.value);
                          }}
                        />
                      </MDBox>
                      <MDBox>
                        <MDInput
                          fullWidth
                          type="text"
                          multiline
                          rows={3}
                          label="Descripción"
                          value={descriptionDate}
                          onChange={(event) => {
                            setDescriptionDate(event.target.value);
                          }}
                        />
                      </MDBox>
                    </AccordionDetails>
                    <AccordionActions>
                      <MDButton variant="gradient" color="success" type="submit" disabled={submitting}>
                        Agregar
                      </MDButton>
                      {renderSuccessSB}
                      {renderErrorSB}
                    </AccordionActions>
                  </Accordion>
                </form>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
        <MDBox pt={3}>
          <ListDate expedienteId={expedienteId} refreshDates={refreshDates}></ListDate>
        </MDBox>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={2}>
        <AddTime
          expedienteId={expedienteId}
          onAddTime={() => setRefreshTimes((prev) => !prev)}
        ></AddTime>
        <MDBox pt={3}>
          <ListTime expedienteId={expedienteId} refreshTimes={refreshTimes}></ListTime>
        </MDBox>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={3}>
        <AddDocument
          expedienteId={expedienteId}
          onAddDocument={() => setRefreshDocuments((prev) => !prev)}
        ></AddDocument>
        <MDBox pt={3}>
          <ListDocuments
            expedienteId={expedienteId}
            refreshDocuments={refreshDocuments}
          ></ListDocuments>
        </MDBox>
      </CustomTabPanel>
      {children}
    </MDBox>
  );
}

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
  expedienteId: PropTypes.number.isRequired,
};

export default Header;
